import * as React from 'react';
import { observer } from 'mobx-react';
import { useSystem } from '../../hooks/useSystem';
import { Notification, NotificationType } from '../../core/stores/NotificationStore';
import { Theme } from '@emotion/react';
import styled from '@emotion/styled';
import { Font } from '../../fonts';

export interface NotificationStoreWidgetProps {
  className?: any;
}

export const NotificationStoreWidget: React.FC<NotificationStoreWidgetProps> = observer((props) => {
  const system = useSystem();
  return (
    <S.Container className={props.className}>
      {system.notification_store.notifications.map((n) => {
        return <NotificationWidget key={n.id} n={n} />;
      })}
    </S.Container>
  );
});

export interface NotificationWidgetProps {
  n: Notification;
}

export const NotificationWidget: React.FC<NotificationWidgetProps> = (props) => {
  return <S.Notification type={props.n.options.type}>{props.n.options.desc}</S.Notification>;
};

namespace S {
  const getTheme = (theme: Theme, type: NotificationType) => {
    if (type === NotificationType.SUCCESS) {
      return theme.notification_success;
    }
    return theme.notification_error;
  };

  export const Container = styled.div``;

  export const Notification = styled.div<{ type: NotificationType }>`
    background: ${(p) => getTheme(p.theme, p.type).background};
    color: ${(p) => getTheme(p.theme, p.type).foreground};
    padding: 10px;
    font-family: ${Font.Normal};
    font-size: 13px;
    text-align: center;
  `;
}
